import { IconWrapper } from '../runtime';
export default IconWrapper('folder-location', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "8",
      "cy": "7.99976",
      "r": "1.5",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.68 7.99976C2.68 10.9379 5.06185 13.3198 8 13.3198C10.9382 13.3198 13.32 10.9379 13.32 7.99976C13.32 5.0616 10.9382 2.67976 8 2.67976M2.68 7.99976C2.68 5.0616 5.06185 2.67976 8 2.67976M2.68 7.99976H1M8 2.67976V0.999756M13.6 7.99976H15M8 13.5998V14.9998",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});